import { render, staticRenderFns } from "./N3OsDados.vue?vue&type=template&id=e2feead4&scoped=true"
import script from "./N3OsDados.vue?vue&type=script&lang=js"
export * from "./N3OsDados.vue?vue&type=script&lang=js"
import style1 from "./N3OsDados.vue?vue&type=style&index=1&id=e2feead4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2feead4",
  null
  
)

export default component.exports